/**
 * useSpacing — returns the canonical spacing scale.
 *
 * Spacing is theme-invariant, so this simply returns the SPACING constant.
 * The hook exists for a consistent API alongside useThemeColors/useTypography/etc.
 *
 * @example
 * const space = useSpacing();
 * <View style={{ padding: space.lg, gap: space.sm }} />
 */
import { SPACING } from '@/constants/shared/theme/spacing';
import type { Spacing } from '@/constants/shared/theme';

export function useSpacing(): Spacing {
  return SPACING;
}
